import React, { useState } from "react";
import "./Login.css";
import { mainBg } from "../../assets/img/imgIndex";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Loader from "../../components/Loader";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email || "");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));

    // Clear error when user starts typing
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {
      email: "",
      password: "",
    };

    // Validate email
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);

    // If no errors, submit the form
    if (!newErrors.email && !newErrors.password) {
      setLoading(true);
      console.log("formData", formData);

      post(URLS.LOGIN, formData)
        .then((res) => {
          if (res?.status === "success") {
            toast.success(res?.message || "Login Successfully");

            if (res?.token) {
              localStorage.setItem("token", res.token);
            }
            if (res?.admin) {
              localStorage.setItem("userId", JSON.stringify(res.admin));
              localStorage.setItem(
                "permissions",
                JSON.stringify(res?.admin?.permissions || [])
              );
            }

            setLoading(false);
            console.log("Login Form Submitted:", formData);

            setTimeout(() => {
              navigate("/dashboard");
            }, 1500);
          } else {
            setLoading(false);
            // toast.error(res?.message || "Login failed");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error("Login error:", err);
          // toast.error(err?.message || "An error occurred during login");
        });
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <img
          src="https://kdba-s3.s3.us-east-1.amazonaws.com/kd-Rectangle.png"
          alt="Cooking"
          className="login-left-img"
        />
      </div>
      <div className="login-right">
        <form className="login-form-wrapper" onSubmit={handleSubmit}>
          <p className="welcome-text">Welcome</p>
          <h1 className="brand-name">Kadugudabba</h1>

          <div className="form-group">
            <label>Email ID</label>
            <input
              type="email"
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
              placeholder="Enter Your email"
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password || ""}
                onChange={handleChange}
                placeholder="***************"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {!showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}
          </div>
          <p
            className="forgot-password"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/forgot-password")}
          >
            Forgot password?
          </p>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Loading..." : "Login"}
          </button>
        </form>
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default Login;
